import type { TimeSeriesChartProps } from './TimeSeriesChart.types';
import { useTimeSeriesChartTheme } from './theme/useTimeSeriesChartTheme';
import { EChartsTimeSeriesChartRenderer } from '../renderers/echarts/time-series-chart/EChartsTimeSeriesChartRenderer';

export function TimeSeriesChart(props: TimeSeriesChartProps) {
  const theme = useTimeSeriesChartTheme();

  return <EChartsTimeSeriesChartRenderer {...props} theme={theme} />;
}
